export class Authentication {
  constructor(public username?: string, public password?: string) {}
}
export class SignUp {
  constructor(
    public email?: string,
    public name?: string,
    public cpf?: string,
    public password?: string,
    public confirmPassword?: string
  ) {}
}

export class ForgotPassword {
  constructor(
    public email?: string,
    public password?: string,
    public confirmPassword?: string
  ) {}
}


export class AuthResponse {
  constructor(public accessToken?: string, public refreshToken?: string) {}
}